module.exports = __webpack_public_path__ + "static/media/LK_Lock.65976286.svg";